module.exports = __webpack_public_path__ + "assets/img/Rules_tit.12623498.png";